/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Status_InactiveInputs */



/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Partner_Referral_Status_InactiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_status_inactive = /** @type {((inputs?: Partner_Referral_Status_InactiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Status_InactiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inaktiv")
	return /** @type {LocalizedString} */ ("Inactive")
});